"use strict";

exports.__esModule = true;
exports.default = locationReducer;

var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function locationReducer(state, action) {
  if (state === void 0) {
    state = null;
  }

  if (action.type === _ActionTypes.default.UPDATE_LOCATION) {
    return action.payload;
  }

  return state;
}

module.exports = exports.default;